<template>
    <form @submit.prevent="formSubmit" v-if="networks != null">
        <!-- <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account1">Desde</label>
                <select class="form-control custom-select" id="account1" v-model="form.network">
                    <option v-for="(network, n_i) in networks" v-bind:key="'ni'+n_i" :value="n_i">{{network.name}}</option>
                </select>
            </div>
        </div>
        <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account2">Activo</label>
                <select class="form-control custom-select" id="account2" v-model="form.asset">
                    <option v-for="(asset_, a_i) in assets" v-bind:key="'ai'+a_i" :value="a_i">{{asset_.currency.name}} ({{asset.currency.symbol}})</option>
                </select>
            </div>
        </div>
        <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account2">Destino</label>
                <select class="form-control custom-select" id="account2" v-model="form.bank">
                    <option value="0">Tether (USDT)</option>
                </select>
            </div>
        </div>
        <div class="form-group basic">
          <label class="label" v-if="asset != null">Ingrese Cantidad - Balance: {{ asset.balance }}</label>
            <div class="input-group mb-2">
              <span class="input-group-text" id="basic-addonb1">{{asset.currency.symbol}}</span>
              <input type="text" class="form-control" placeholder="Ingrese una cantidad" v -model="form.amount" />
            </div>
        </div>
        <div class="form-group basic-">
            <ul class="nav nav-tabs capsuled" role="tablist">
                <li class="nav-item" v-for="(fee, f) in options.fee" v-bind:key="'afee-'+f">
                    <a class="nav-link" data-bs-toggle="tab" :href="'#fee-'+f" role="tab" @click="form.fee=f">
                        {{ fee.name }}
                    </a>
                </li>
            </ul>
            <div class="tab-content mt-1">
                <div class="tab-pane fade" :id="'fee-'+f" role="tabpanel" v-for="(fee, f) in options.fee" v-bind:key="'afee-'+f">
                  <p>{{ fee.description }}</p>
                  <hr>
                  Cantidad: {{ parseFloat(form.amount) }} {{ asset.currency.symbol }} <br />
                  Precio de venta: {{ asset.currency.price.buy }} COP  X 1 {{ asset.currency.symbol }}<br />
                  Comision: {{ comision }} COP X 1 {{ asset.currency.symbol }}<br />
                  <hr>
                  Subtotal: {{ subtotal }} COP <br />
                  Fee: {{ feetotal }} COP <br />
                  Total: {{ total }} COP <br />
                  <hr>
                </div>
            </div>
        </div> -->

        <div class="card">
            <div class="card-body">
            </div>
        </div>

        <div class="form-group basic">
            <button type="submit" class="btn btn-primary btn-block btn-lg">Enviar</button>
        </div>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
      // networks: [],
      form: {
        network: 0,
        asset: 0,
        amount: 1,
        fee: 0,
        bank: 0,
      },
      options: {
        fee: [
          {
            name: 'Express',
            description: 'Si necesitas vender de manera urgente sin importar las comisiones variables hasta un 10% puedes usar este metodo.',
            type_fee: 'percentage',
            fee: '10'
          },
          {
            name: 'Regular',
            description: 'Si necesitas vender tu activo con comisiones estables durante para recibirlos en un plazo aproximado de 24 Horas usa este metodo.',
            type_fee: 'percentage',
            fee: '7'
          },
          {
            name: 'Pro',
            description: 'Si deseas esperar un poco y vender tu activo con una excelente comision usa este metodo.',
            type_fee: 'percentage',
            fee: '4'
          },
        ]
      }
    };
  },
  watch: {
    'form.network'() {
      this.form.asset = 0;
    }
  },
  computed: {
    ...mapState(['userData', 'balance', 'last']),
    // subtotal() {
    //   return (this.form.amount * this.asset.currency.price.sell) ?? 0;
    // },
    // feetotal() {
    //   return (this.form.amount * this.comision) ?? 0;
    // },
    // total() {
    //   return (this.subtotal - this.feetotal) ?? 0;
    // },
    // comision() {
    //   if (this.fee !== null) {
    //     if (this.fee.type_fee == 'percentage') {
    //       return (this.asset.currency.price.sell * this.fee.fee) / 100;
    //     }
    //     else if (this.fee.type_fee == 'amount') {
    //       return this.fee.fee;
    //     }
    //   }
    //   return 999999999;
    // },
    // networks() {
    //   return this.$root.networks.balances;
    // },
    // fee() {
    //   return this.options.fee[this.form.fee] ?? null;
    // },
    // network() {
    //   return this.networks[this.form.network] ?? null;
    // },
    // asset() {
    //   return this.assets[this.form.asset] ?? null;
    // },
    // assets() {
    //   if (this.network != null) {
    //     return this.network.assets;
    //   }
    //   return [];
    // }
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
    // console.clear()
    // console.log('networks', this.networks)
  },
  methods: {
    ...mapActions(['logoutAPI', 'newNotification', 'createSellAPI']),
    async formSubmit() {
      console.log('formSubmit', this.asset)
      if (parseFloat(this.asset.balance) < parseFloat(this.form.amount)) {
        await this.newNotification({
          type: 'danger',
          title: 'Fondos insuficientes',
          message: 'No tienes fondos suficientes para esta transaccion.'
        })
      } else {
        const data = {
          asset: this.asset.id,
          amount: this.form.amount,
        }
        console.log('data', data)
        const response = await this.createSellAPI(data)
        console.log('response', response)
      }
      return false;
    },
  },
}
</script>